import { createAction, props } from '@ngrx/store';

import { InfiniteScrollResponse } from '@lib/core/models/infinite-scroll-response.interface';
import { SystemUserProfile } from '@lib/core/models/system-user.interface';

import { Task, TaskAssignPayload, TaskResolvePayload, TaskSearchPayload, TasksFilter } from '../models/task.interface';

// Set Tasks Filter
export const setTasksFilter = createAction('[Task] Set Tasks Filter', props<{ filter: TasksFilter }>());

// Fetching Tasks By Specific Method
export const fetchTasksFirstPage = createAction('[Task] Fetch Tasks First Page');
export const fetchTasksNextPage = createAction('[Task] Fetch Tasks Next Page');

// Get Tasks List (internal action used by effects)
export const getTasksList = createAction('[Task] Get Tasks List', props<{ payload: TaskSearchPayload }>());
export const getTasksListSuccess = createAction('[Task] Get Tasks List Success', props<{ response: InfiniteScrollResponse<Task> }>());
export const getTasksListFailure = createAction('[Task] Get Tasks List Failure', props<{ error: any }>());

// Start Task
export const startTask = createAction('[Task] Start Task', props<{ task: Task }>());
export const startTaskSuccess = createAction('[Task] Start Task Success', props<{ task: Task }>());
export const startTaskFailure = createAction('[Task] Start Task Failure', props<{ task: Task; error: any }>());

// Assign Task
export const assignTask = createAction('[Task] Assign Task', props<{ task: Task; payload: TaskAssignPayload }>());
export const assignTaskSuccess = createAction('[Task] Assign Task Success', props<{ task: Task }>());
export const assignTaskFailure = createAction('[Task] Assign Task Failure', props<{ task: Task; error: any }>());

// Resolve Task
export const resolveTask = createAction('[Task] Resolve Task', props<{ task: Task; payload: TaskResolvePayload }>());
export const resolveTaskSuccess = createAction('[Task] Resolve Task Success', props<{ task: Task }>());
export const resolveTaskFailure = createAction('[Task] Resolve Task Failure', props<{ task: Task; error: any }>());

// Get Current Task
export const getCurrentTask = createAction('[Task] Get Current Task', props<{ id: string; createdAt?: Date }>());
export const getCurrentTaskSuccess = createAction('[Task] Get Current Task Success', props<{ task: Task }>());
export const getCurrentTaskFailure = createAction('[Task] Get Current Task Failure', props<{ error: any }>());

// Clear State
export const clearCurrentTask = createAction('[Task] Clear Current Task');
export const clearTasksList = createAction('[Task] Clear Tasks List');

// New Tasks Count Polling
export const startNewTasksCountPolling = createAction('[Task] Start New Tasks Count Polling');
export const stopNewTasksCountPolling = createAction('[Task] Stop New Tasks Count Polling');
export const getNewTasksCountSuccess = createAction('[Task] Get New Tasks Count Success', props<{ count: number }>());
export const getNewTasksCountFailure = createAction('[Task] Get New Tasks Count Failure', props<{ error: any }>());

// System Users (for assignee picker)
export const loadSystemUsers = createAction('[Task] Load System Users');
export const loadSystemUsersSuccess = createAction('[Task] Load System Users Success', props<{ users: SystemUserProfile[] }>());
export const loadSystemUsersFailure = createAction('[Task] Load System Users Failure', props<{ error: any }>());
